const button = document.getElementById('custom-open-filters-button');
const sidebarFilters = document.querySelector('.woocommerce .sidebar-inner');

if (button) {
	button.onclick = function () {
		let height = getComputedStyle(sidebarFilters).height;
		if (height === '0px') {
			sidebarFilters.style.height = 'auto';
		} else {
			sidebarFilters.style.height = 0;
		}
	}
}
